<template>
  <div class="body" id="bj">
      <Headtow></Headtow>
      <div >
        <div id="w-center">
          <div id="Breadcrumb">
            <i class="el-icon-house Breadcrumb-i" ></i>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
              <el-breadcrumb-item>会员中心</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!-- 左侧 -->
          <Memberleft></Memberleft>

          <!-- 左侧结束 -->
          <div class="w-products rihgt">
            <div class="Member-right">
                <p class="content-jj">编辑老师</p>
            </div>
            <div class="h-20"></div>
            <div class="w-products rihgt Member-right">
              <div class="member-label DeviceInfos">
                <el-tabs>

                  <el-tab-pane>
                    <span slot="label">编辑老师</span>

                    <el-table
                        v-loading="loading"
                        ref="multipleTable"
                        :data="list"
                        style="width: 100%"
                        >
                        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
                        <el-table-column label="用户名 " width="120">
                          <template slot-scope="scope">{{ scope.row.username }}</template>
                        </el-table-column>
                        <el-table-column label="电话 " width="120">
                          <template slot-scope="scope">{{ scope.row.mobile }}</template>
                        </el-table-column>
                        <el-table-column label="发布时间" show-overflow-tooltip>
                          <template slot-scope="scope">{{ scope.row.create_time }}</template>
                        </el-table-column>
                        <el-table-column label="状态 " width="120">
                          <template slot-scope="scope">{{ scope.row.status_text }}</template>
                        </el-table-column>
                        <el-table-column label="操作">
                          <template slot-scope="scope">
                            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <!-- <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                          </template>
                        </el-table-column>
                      </el-table>
                      <div class="page">
                        <el-pagination
                          background
                          layout="prev, pager, next"
                          :page-size="8"
                          @current-change="handleCurrentChange"
                          :total="total">
                        </el-pagination>
                      </div>
                  </el-tab-pane>



                  <el-tab-pane>
                    <span slot="label">添加老师</span>
                    <el-form ref="form" :model="form" label-width="100px" v-loading="loading">
                      <!-- <el-form-item label="头像：" >
                          <el-upload
                            class="avatar-uploader"
                            action="http://pc.zyjlfwpt.com/api.php/Upload/uploadcords"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                          </el-upload>
                      </el-form-item> -->
                      <el-form-item label="用户名：">
                        <el-input placeholder="请输入用户名"  v-model="form.username"></el-input>
                      </el-form-item>
                      <el-form-item label="电话：">
                        <el-input placeholder="请输入电话"  v-model="form.mobile"></el-input>
                      </el-form-item>
                      <el-form-item label="设置新密码" prop="pass">
                        <el-input type="password"  placeholder="请设置新密码" v-model="form.pass" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item label="确认密码"  prop="checkPass">
                        <el-input type="password" placeholder="请确认密码" v-model="form.checkPass" autocomplete="off"></el-input>
                      </el-form-item>
                      <el-form-item>
                        <el-button type="primary" @click="onSubmit(form)" size="medium">提交</el-button>
                      </el-form-item>
                    </el-form>
                  </el-tab-pane>




                </el-tabs>
              </div>
              <div class="h-30"></div>
              <div class="h-30 clear"></div>
              <div class="h-30"></div>
            </div>

          </div>

          <div class="clear"></div>

        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue';
import memberleft from '@/components/public/memberleft.vue'
export default{
  data(){
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
     loading:true,
     activeIndex: '3',
     imageUrl: '',
     user:[],
     form: {
         // names: '',
         username:'',
         // sex:'',
         // headimgurl:'',
         pass:'',
         checkPass:'',
         mobile:'',
     },
     rules: {
       pass: [
         {  required: true,validator: validatePass, trigger: 'blur' }
       ],
       checkPass: [
         {  required: true,validator: validatePass2, trigger: 'blur'}
       ],
     },

     list: [],
     page:1,
     total:0,

    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
    'Memberleft': memberleft,
  },




  mounted () {
    this.recordapi();
  },
  methods:{

    handleEdit(index, row) {
       console.log(1);
       this.$router.push({path:'/MemberNewsEdit',query:{id:row.id,memberindex:3}});
     },

    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Member/MemberInfo",{'userid':userid}).then(res => {
          console.log(res);
           if(res.code == 1){
             that.user= res.user;
             this.list = res.list.data;
             this.total = res.list.total
             this.loading = false

           }

        });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleAvatarSuccess(res, file) {
        console.log();
        console.log(file);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.form.headimgurl = res.path;
    },
    beforeAvatarUpload(file) {
         const isJPG = file.type === 'image/jpeg/png/jpg';

        // const isJPG = file.type = ['image/jpeg', 'image/jpg', 'image/png'];

        const isLt2M = file.size / 1024 / 1024 < 5;

        // if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
        //   this.$message.error('上传头像图片只能是 JPG,jpeg,png 格式!');
        // }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        return  isLt2M;
    },
   // 添加提交
   onSubmit(form) {
     console.log(form);
     if(form.checkPass !== form.pass ){
        this.$message.error('俩次密码输入不一样');
        return
     }
     if(form.checkPass =='' ||  form.pass=='' ){
       this.$message.error('请输入密码');
       return
     }
     var that = this;
       var userid = that.$cookieStore.getCookie('userid');
       that.$api.post("/Member/addls",{'password':form.checkPass,'userid':userid,'username':form.username,'mobile':form.mobile}).then(res => {
           console.log(res);
           if(res.code==1){
             that.show = false;
             this.$message({
               message: res.msg,
               type: 'success'
             });
             this.form.username = '';
             this.form.pass = '';
             this.form.checkPass = '';
             this.form.mobile = '';
           }
       })

   },

  }

 }
</script>



// WEBPACK FOOTER //
// src/components/MemberInfoedit.vue